'use client';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ButtonStyleEnum, ButtonIconEnum } from '@enums/button-enums.js';
import { MediaType, MetaProps } from '@repo/ui/src/types';

import { Image, AuthorContent } from './styles';

interface AuthorCardProps {
  _meta: MetaProps;
  name?: string;
  avatar?: MediaType;
  featuredQuote?: string;
  heading?: string;
  link?: string;
  linkLabel?: string;
  _testID?: string;
  index?: number;
}

const AuthorCard = ({
  _meta,
  name,
  avatar,
  featuredQuote,
  heading,
  link,
  linkLabel,
  _testID,
  index,
}: AuthorCardProps) => {
  const smAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('sm'));
  const buttons = [
    {
      link: { link: _meta.deliveryKey, label: linkLabel, displayName: link },
      style: ButtonStyleEnum.Text,
      icon: ButtonIconEnum.Skewer,
    },
  ];
  const imgUrl = buildImageSrc(avatar, smAndUp ? 700 : 600, smAndUp ? 9 : 1, smAndUp ? 10 : 1);

  return (
    <Grid container className="tw-h-full" data-test-id={`author_card_${_testID}${index}`}>
      <Grid item xs={12} sm={6}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image imgComponent={<img src={imgUrl} alt={name} />} className="tw-h-full tw-w-auto" />
      </Grid>
      <Grid item xs={12} sm={6} container>
        <AuthorContent
          divider
          align="left"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          heading={name}
          headingStyleVariant="h2"
          lilHeading={heading}
          lineClamp={4}
          description={featuredQuote ? `“${featuredQuote}”` : undefined}
          buttons={buttons}
        />
      </Grid>
    </Grid>
  );
};

export default AuthorCard;
